import React from "react";
import { Link } from "react-router-dom";

type BrandButtonProps = {
  href?: string;
  to?: string;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  external?: boolean;
  "data-testid"?: string;
};

export const BrandButton: React.FC<BrandButtonProps> = ({
  href,
  to,
  onClick,
  children,
  className = "",
  external = false,
  ...rest
}) => {
  const classes = `group inline-flex items-center gap-2 rounded-[16px] bg-ink px-7 py-4 text-[15px] font-semibold text-canvas transition-transform duration-200 ease-out hover:-translate-y-0.5 hover:shadow-[0_10px_24px_-8px_rgba(24,25,19,0.35)] active:translate-y-0 ${className}`;
  const content = (
    <>
      <span>{children}</span>
      <span className="transition-transform duration-200 ease-out group-hover:translate-x-1">-&gt;</span>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes} onClick={onClick} {...rest}>
        {content}
      </Link>
    );
  }
  if (href) {
    return (
      <a
        href={href}
        className={classes}
        onClick={onClick}
        target={external ? "_blank" : undefined}
        rel={external ? "noopener noreferrer" : undefined}
        {...rest}
      >
        {content}
      </a>
    );
  }
  return (
    <button type="button" className={classes} onClick={onClick} {...rest}>
      {content}
    </button>
  );
};
